module.exports = __webpack_public_path__ + "static/media/website-03.e5a6a379.png";